/**
 * Bundle 141 - Operations landing page.
 * Route: /admin/operations
 */
import React from 'react';
import AdminSectionLandingPage from './AdminSectionLandingPage';

const AdminOperationsLandingPage = () => (
  <AdminSectionLandingPage
    section="operations"
    testidPrefix="admin-operations-landing"
  />
);

export default AdminOperationsLandingPage;
